import React from 'react';
import { Lock } from 'lucide-react';

/**
 * A fully-blurred school card shown before unlock.
 * Shows a short teaser line ABOVE the blur (not blurred) + tiny blurred fee bar.
 * The content beneath is pointer-events: none so clicks go to the unlock overlay.
 */
const BlurredSchoolCard = ({ index, teaser, miniBars = [] }) => {
  return (
    <div className="relative rounded-2xl overflow-hidden border border-[#E8DED3] bg-[#FEFDF8]" data-testid={`blurred-card-${index}`}>
      {/* Faux content (blurred) */}
      <div className="p-5 select-none pointer-events-none" aria-hidden="true"
           style={{ filter: 'blur(8px)' }}>
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-[#F28B66]/30" />
          <div className="flex-1 space-y-1.5">
            <div className="h-4 w-2/3 rounded bg-[#E8DED3]" />
            <div className="h-3 w-1/3 rounded bg-[#E8DED3]" />
          </div>
          <div className="h-7 w-14 rounded-full bg-[#FFB88C]/40" />
        </div>
        <div className="h-3 w-full rounded bg-[#E8DED3] mb-1.5" />
        <div className="h-3 w-5/6 rounded bg-[#E8DED3] mb-4" />
        {/* mini bar chart */}
        <div className="flex items-end gap-1 h-14">
          {(miniBars.length ? miniBars : [24, 32, 42, 50, 62, 70]).map((h, i) => (
            <div key={i} className="flex-1 rounded-t bg-[#E85D35]/30" style={{ height: `${h}%` }} />
          ))}
        </div>
      </div>

      {/* Overlay with teaser — NOT blurred */}
      <div className="absolute inset-0 flex flex-col justify-between p-5 bg-[#FEFDF8]/40 backdrop-blur-[1px]">
        <div className="flex items-center gap-2">
          <Lock className="w-4 h-4 text-[#E85D35]" />
          <span className="text-xs font-bold uppercase tracking-wider text-[#E85D35]">
            {index != null ? `Match #${index}` : 'Near-miss'}
          </span>
        </div>
        <p className="text-sm sm:text-base font-medium text-[#2C2823] bg-white/80 rounded-lg px-3 py-2 self-start max-w-[90%] shadow-sm">
          {teaser || 'Details hidden until you unlock the full report.'}
        </p>
      </div>
    </div>
  );
};

export default BlurredSchoolCard;
